/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    instanceOfDeviceInterfaceType,
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';

/**
 * @type EquipmentTypeCatalogDtoDeviceInterfaceType
 * 
 * @export
 */
export type EquipmentTypeCatalogDtoDeviceInterfaceType = DeviceInterfaceType;


export function EquipmentTypeCatalogDtoDeviceInterfaceTypeFromJSON(json: any): EquipmentTypeCatalogDtoDeviceInterfaceType {
    return EquipmentTypeCatalogDtoDeviceInterfaceTypeFromJSONTyped(json, false);
}

export function EquipmentTypeCatalogDtoDeviceInterfaceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentTypeCatalogDtoDeviceInterfaceType {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...DeviceInterfaceTypeFromJSONTyped(json, true) };
    return  DeviceInterfaceTypeFromJSONTyped(json, true);
}

export function EquipmentTypeCatalogDtoDeviceInterfaceTypeToJSON(value?: EquipmentTypeCatalogDtoDeviceInterfaceType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfDeviceInterfaceType(value)) {
        return DeviceInterfaceTypeToJSON(value as DeviceInterfaceType);
    }

    return {};
}

/**
 * Check if a given object implements the EquipmentTypeCatalogDtoDeviceInterfaceType interface.
 */
export function instanceOfEquipmentTypeCatalogDtoDeviceInterfaceType(value: any): value is EquipmentTypeCatalogDtoDeviceInterfaceType {
    if (instanceOfDeviceInterfaceType(value)) return true;
    return false;
}

